import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';

type updateStepParams = {
  uuid: string;
  completed: boolean;
  started: boolean;
  step_action: string;
};

export const updateTaskStep = async ({ uuid, completed, started, step_action }: updateStepParams) => {
  if (!uuid) return null;
  const response = await CustomAxios.post('tasks/update-step', { uuid, completed, started, step_action });
  const { data } = response;
  return data;
};

export function useUpdateTaskStep() {
  return useMutation({
    mutationFn: (params: updateStepParams) => updateTaskStep(params),
    onError: (err: AxiosError) => {
      console.error('Error updating step:', err);
    },
    // TODO: invalidate query for parent task
  });
}
